import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-sign-road-2",
  "use": "icon-si-glyph-sign-road-2-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-sign-road-2\" id=\"icon-si-glyph-sign-road-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>145</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M13.633,3.938 L16,2.562 L13.633,1.105 L8.979,1.523 L8.979,0.021 L7,0.021 L7,1.594 L3.021,2.021 L3.021,4.854 L7,4.428 L7,7.491 L2.378,7.054 L0,8.375 L2.378,9.854 L7,10.264 L7,15.938 L8.979,15.938 L8.979,10.341 L12.958,10.854 L12.958,8.055 L8.979,7.678 L8.979,4.357 L13.633,3.938 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-sign-road-2.svg
// module id = nXXn
// module chunks = 62